<template>
  <div class="statBlock">
    <div class="bar"></div>

    <div id="content-wrap">
      <creature-heading :text="init_stats.name"/>
      <creature-type text="Medium construct, unaligned"/>
      <top-stats>
        <property-line header="Armor Class" text="18 (natural armor)"/>        
        <property-line header="Hit Points" text="33 (6d8 + 6)"/>
        <property-line header="Speed" text="25ft"/>
        
        <abilities-block :score_str=14
                        :score_dex=11
                        :score_con=13
                        :score_int=1
                        :score_wis=3
                        :score_cha=1></abilities-block>

        <property-line header="Damage Immunities" text="poison, psychic"/>
        <property-line header="Condition Immunities" text="blinded, charmed, deafened, exhaustion, frightened, paralyzed,
              petrified, poisoned"/>
        <property-line header="Senses" text="blindsight 60 ft. (blind beyond this radius), passive Perception 6"/>
        <property-line header="Languages" text="—"/>
        <property-line header="Challenge" text="1 (200 XP)"/>
      </top-stats>
      <div class="listContainer" @mouseover="hover = true" @mouseleave="hover = false">
        <transition-group name="itemList" tag="p">
          <div class="traitAddedItem" v-for="(trait, index) in traits" :key="trait.uid">
            <b-icon-x-circle class="deleteButton" @click="deleteRow(index, traits)"></b-icon-x-circle>
            <property-block :header="trait.name" :text="trait.description"/>
          </div>
        </transition-group>
      </div>
      <h3 class="header">Actions</h3>

      <transition-group name="itemList" tag="p">
        <div class="listContainer" v-for="(action, index) in actions" :key="action.uid">
          <b-icon-x-circle class="deleteButton" @click="deleteRow(index, actions)"></b-icon-x-circle>
          <property-block :header="action.name" :text="action.description"/>
        </div>
      </transition-group>

      <p class="h2 mb-2" v-show="!checkLegendAction()">
        <b-icon-plus class="addLegendButton" @click="isLegendAction = true;">
        </b-icon-plus>
      </p>
      <!-- <p class="h2 mb-2" v-show="isLegendAction">
        <b-icon-trash class="addLegendButton" @click="removeLegendaryActions">
        </b-icon-trash>
      </p> -->
      <h3 class="header" v-show="checkLegendAction()">Legendary Actions</h3>
      <div class="listContainer">
        <transition-group name="itemList" tag="p">
          <div  v-for="(l_action, index) in legend_actions" :key="l_action.uid">
            <b-icon-x-circle class="deleteButton" @click="deleteRow(index, legend_actions)"></b-icon-x-circle>
            <property-block :header="l_action.name" :text="l_action.description"/>
          </div>
        </transition-group>
      </div>
    </div>

    <div class="bar"></div>
   
  </div>
</template>

<script>
import CreatureHeading from './CreatureHeading.vue';
import CreatureType from './CreatureType.vue';
import propertyLine from './propertyLine.vue';
import topStats from './topStats.vue';
import abilitiesBlock from './abilitiesBlock.vue';
import propertyBlock from './propertyBlock.vue';

import MMJSON from '../assets/mm_init.json';

export default {
  name: 'statBlock',
  props:{
    traits: Array,
    actions: Array,
    legend_actions: Array,
  },
  data(){
    return{
      hover : false,
      init_stats : MMJSON.monster[0],
      isLegendAction : false,
    }
  },
  components: {
    'creature-heading': CreatureHeading,
    'creature-type': CreatureType,
    'property-line': propertyLine,
    'top-stats': topStats,
    'abilities-block': abilitiesBlock,
    'property-block': propertyBlock,
  },
  methods:{
    deleteRow(index, arr){
      arr.splice(index,1);
    },
    addLegendaryActions(){
      this.isLegendAction = true;
    },
    checkLegendAction(){
      if(this.legend_actions.length > 0){
        this.isLegendAction = true;
      }else{
        this.isLegendAction = false;
      }
      return this.isLegendAction;
    } 
  },
}
</script>



<style> 
  .bar {
    height: 5px;
    background: #E69A28;
    border: 1px solid #000;
    position: relative;
    z-index: 1;
  }

  .statBlock {
    /* display: inline-block; */
    margin-left : 35px;
    padding-right: 25px;

  }

  #content-wrap {
    font-family: 'Noto Sans', 'Myriad Pro', Calibri, Helvetica, Arial,
                  sans-serif;
    font-size: 13.5px;
    background: #FDF1DC;
    padding: 0.6em;
    padding-bottom: 0.5em;
    border: 1px #DDD solid;
    box-shadow: 0 0 1.5em #867453;

    /* We don't want the box-shadow in front of the bar divs. */
    position: relative;
    z-index: 0;

    /* Leaving room for the two bars to protrude outwards */
    margin-left: 2px;
    margin-right: 2px;

    /* This is possibly overriden by next CSS rule. */
    width: 420px;

    -webkit-columns: 400px;
       -moz-columns: 400px;
            columns: 400px;
    -webkit-column-gap: 40px;
       -moz-column-gap: 40px;
            column-gap: 40px;

    /* We can't use CSS3 attr() here because no browser currently supports it,
       but we can use a CSS custom property instead. */
    height: var(--data-content-height);

    /* When height is constrained, we want sequential filling of columns. */
    -webkit-column-fill: auto;
       -moz-column-fill: auto;
            column-fill: auto;
  }

  :host([data-two-column]) #content-wrap {
    /* One column is 400px and the gap between them is 40px. */
    width: 840px;
  }

  h3.header{
    border-bottom: 1px solid #7A200D;
    color: #7A200D;
    font-size: 21px;
    font-variant: small-caps;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 0;
    margin-bottom: 0.3em;

    break-inside: avoid-column;
    break-after: avoid-column;
  }

  /* For user-level p elems. */ 
  p{
    margin-top: 0.3em;
    margin-bottom: 0.9em;
    line-height: 1.5;
  }

  td:focus{
    background-color: white;
  }

  /* Last child shouldn't have bottom margin, too much white space. */
  .statBlock:last-child{
    margin-bottom: 0;
  }

  .deleteButton{
    opacity: 40%;
    position: absolute;
    left: -33px;
    margin-top: 5px;
    fill: #000;
    cursor: pointer;
  }

  .deleteButton:hover{
    opacity: 100%;
    /* position: absolute; */
    left: -33px;
  }

  .addLegendButton{
    opacity: 40%;
    position: absolute;
    left: -34px;
    cursor: pointer;
  }

  .addLegendButton:hover{
    opacity: 100%;
  }

 .listContainer{
    position: relative;
 }

 .itemList-item {
  display: inline-block;
  margin-right: 5px;
  }
  .itemList-enter-active{
    transition: all 0.4s;
  }
    .itemList-leave-active {
    transition: all 0.25s;
  }
  .itemList-enter, .itemList-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(-15px);
  }

</style>